<template>
	<div class="form-selection">
		<div class="homework-item">
			<div class="homework-item-title">
				<span>{{index}}</span>
				{{questionObj.subject}}
				<i v-if="questionObj.examplesUrl"  @click="clickShow(questionObj)" title="不会填写，查看示例" class="iconfont icon-wen"></i>
			</div>
			<div class="homework-txt" v-if="questionObj.answer && questionObj.questionList.length > 1" v-html="questionObj.answer"></div>

				<el-form ref='form' :model='formData'>
					<div :class="questionObj.questionList.length === 1 ? 'homework-border' : 'homework-border2'">
						<div v-for="item in Object.keys(formData)" :key="item" >
							<!-- 判断this.questionObj.questionList 的length，form-text-wrapper的宽度 -->
							<template v-if="formData[item]['answerType'] === '1'">
								<el-form-item >
									<FormItemText :answerClassification='formData[item].answerClassification' v-model='formData[item].answerInfo' :lineNumber='formData[item].lineNumber' :restrict='formData[item].restrict' :count="questionObj.questionList.length"/>
								</el-form-item>
							</template>
							<div  v-if="formData[item]['answerType'] === '2'" class="homework-img" :class="formData[item].answerClassification ? 'homework-img-txt' : ''">
								<div class="homework-item-txt">{{formData[item].answerClassification}}</div>
								<FormItemImg :imageUrl.sync="formData[item].answerInfo"  ></FormItemImg>
							</div>
							<template v-if="formData[item]['answerType'] === '4'">
								<FormItemTextSEO :answerClassification='formData[item].answerClassification' v-model='formData[item].answerInfo' :lineNumber='formData[item].lineNumber' :restrict='formData[item].restrict' :count="questionObj.questionList.length"/>
							</template>
						</div>
					</div>
				</el-form>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import FormItemText from './FormItemText'
import FormItemTextSEO from './FormItemTextSEO'
import FormItemImg from './FormItemImg'
export default {
	name: 'FormSelection',
	components: {
		FormItemText,
		FormItemTextSEO,
		FormItemImg
	},
	props: {
		example: Number,
		index: Number,
		questionObj: Object
	},
	data() {
		return {
		}
	},

	computed: {
		formData: {
			get() {
				let obj = {}
				this.questionObj.questionList.forEach(prop => {
					obj[prop.questionId] = prop
				})
				return obj
			},
			set() {}
		}
	},
	methods: {
		clickShow(val){
			this.$emit('example',val)
		},
	}
}
</script>

<style lang="scss" scoped>

.homework-item{
	border: solid 1px #dedede;
	margin-bottom: 19px;
	margin-left:10px ;
	textarea{
		border: 0;
	}

}
.homework-item-txt{
	position: absolute;
	top: 0;
	font-size: 16px;
	font-weight: bold;
	line-height: 20px;
	color: #666666;
	z-index: 99;
	margin-bottom: 10px;
}

.homework-item-title{
	position: relative;
	height: 60px;
	padding-left:60px;
	border-bottom: solid 1px #dedede;
	font-size: 18px;
	line-height: 60px;
	color: #000000;
	span{
		display: block;
		position: absolute;
		top: 9px;
		left:-12px ;
		width: 58px;
		height: 44px;
		background: url(../../../../assets/images/homework/homework-icon1.png) no-repeat left bottom;
		font-size:26px;
		font-family: arial;
		font-style: italic;
		color: #fff;
		text-align: center;
		line-height: 38px;
	}
	i{
		color: #367BF6;
		font-size: 20px;
		margin-left: 8px;
		cursor: pointer;
	}
}

.homework-img{
	margin: 10px 20px 20px;
	height: 259px;
}
.homework-img-txt{
	padding-top: 30px;
	position: relative;
}
.homework-flex{
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;

	.homework-img{
		width: 438px;
		height: 417px;
	}
	.homework-int1{
		width: 425px;

	}
}
</style>
